// src/components/plan/DisclaimersTab.js
import React from 'react'

function DisclaimersTab({ plan }) {
  const disclaimers = plan?.disclaimers || []

  return (
    <div>
      <h4 style={{ fontSize: '1rem', marginBottom: '0.5rem' }}>⚠️ Disclaimers</h4>
      {disclaimers.length > 0 ? (
        <ul style={{ paddingLeft: 0, listStyle: 'none' }}>
          {disclaimers.map((d, i) => (
            <li key={i} style={{ marginBottom: '0.5rem' }}>{d}</li>
          ))}
        </ul>
      ) : (
        <p>None</p>
      )}
    </div>
  )
}

export default DisclaimersTab
